import type { PropsWithChildren } from "react";

export function TestBox(props: PropsWithChildren) {
  return (
    <>
      {props.children}
      {/* biome-ignore lint/style/useSelfClosingElements: CustomElements cannot be self-closing */}
      <testbox-sdk origin={process.env.TBX_ORIGIN}></testbox-sdk>
    </>
  );
}
